import { getAssetCommandItems } from '../commandBarItems/board/getAssetCommandItems';
import { getClearSelectionMenuItem } from '../commandBarItems/board/getClearSelectionMenuItem';
import { getCreateAssetMenuItem } from '../commandBarItems/board/getCreateAssetMenuItem';
import { getBackgroundColorMenuItem } from '../commandBarItems/board/getBackgroundColorMenuItem';
import { getGoToTodayMenuItem } from '../commandBarItems/getGoToTodayMenuItem';
import { getViewSwitcherMenuItem } from '../commandBarItems/getViewSwitcherMenuItem';
import type { CalendarModuleCommandBarConfig } from '../schema';
import { lazyGetSelectedAssets } from 'owa-calendar-board';
import { getLockAssetsMenuItem, getLockCanvasMenuItem } from 'owa-calendar-board-commanding';
import {
    getCalendarBoardAssetRegistry,
    getNumInitialMenuItemsToShow,
} from 'owa-calendar-board-assets';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getNewOutlookToggle } from '../commandBarItems/getNewOutlookToggle';
import { isToggleEnabled } from 'native-newoutlook-toggle';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getFeedbackMenuItem } from '../commandBarItems/getFeedbackMenuItem';

export function getBoardCommandBarConfig(
    onCustomRenderSubMenuChange: () => void,
    isShowAllAssetsExpanded: boolean,
    toggleIsShowAllAssetsExpanded: (newValue: boolean) => void
): CalendarModuleCommandBarConfig {
    const getSelectedAssets = lazyGetSelectedAssets.tryImportForRender();
    const boardSelectedAssets = getSelectedAssets ? getSelectedAssets() : [];
    const selectedAssetCount = boardSelectedAssets?.length;

    let primaryItems = [getGoToTodayMenuItem()];

    const assetRegistry = getCalendarBoardAssetRegistry();
    const boardMenuAssets = assetRegistry?.menuAssets;

    const createAssetMenuItem = boardMenuAssets
        ? getCreateAssetMenuItem(boardMenuAssets, {
              isShowAllAssetsExpanded: isShowAllAssetsExpanded,
              onShowAllAssetsToggled: (
                  event?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>
              ) => {
                  if (event) {
                      event.preventDefault();
                      toggleIsShowAllAssetsExpanded(!isShowAllAssetsExpanded);
                  }
              },
              numInitialItemsToShow: getNumInitialMenuItemsToShow(),
          })
        : null;

    if (createAssetMenuItem) {
        primaryItems.push(createAssetMenuItem);
    }

    if (isFeatureEnabled('cal-board-backgroundColor')) {
        primaryItems.push(getBackgroundColorMenuItem());
    }

    if (selectedAssetCount > 0) {
        primaryItems.push(
            ...getAssetCommandItems(boardSelectedAssets),
            getClearSelectionMenuItem()
        );
    }

    const lockAssetsCommandItem = getLockAssetsMenuItem();
    const lockCanvasCommandItem = getLockCanvasMenuItem();
    return {
        primaryItems,
        farItems: [
            ...(isFeatureEnabled('cal-board-lockCanvas') && lockCanvasCommandItem
                ? [lockCanvasCommandItem]
                : []),
            ...(lockAssetsCommandItem ? [lockAssetsCommandItem] : []),
            getViewSwitcherMenuItem(onCustomRenderSubMenuChange),
            ...(isFeatureEnabled('fwk-feedbackCharm') && isHostAppFeatureEnabled('ribbonFeedback')
                ? [getFeedbackMenuItem()]
                : []),
            ...(isToggleEnabled() ? [getNewOutlookToggle()] : []),
        ],
    };
}
